export const disabledStyle = {
  background: "background.grey.250",
  color: "text.third",
};
